import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t, i18n } = useTranslation('common');
  const isLatvian = i18n.language === 'lv';

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img
                src="https://static.readdy.ai/image/bb12603af26d1f2ac82c77bdc32217c8/659ec9572fd869514b19000180e70d49.png"
                alt="The Daeg International"
                className="h-12 w-auto object-contain"
                style={{ filter: 'drop-shadow(0 0 8px rgba(255,255,255,0.7)) drop-shadow(0 0 16px rgba(255,255,255,0.4))' }}
              />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              {t('footer.about.desc')}
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-amber-400">{t('footer.services.title')}</h3>
            <ul className="space-y-2">
              {!isLatvian && (
                <li>
                  <Link
                    to="/dinh-cu-latvia"
                    className="text-gray-400 hover:text-amber-400 transition-colors text-sm"
                  >
                    {t('footer.services.investment')}
                  </Link>
                </li>
              )}
              <li>
                <Link
                  to="/cho-hem"
                  className="text-gray-400 hover:text-amber-400 transition-colors text-sm"
                >
                  {t('footer.services.choHem')}
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-gray-400 hover:text-amber-400 transition-colors text-sm"
                >
                  {t('footer.services.export')}
                </Link>
              </li>
              {!isLatvian && (
                <li>
                  <Link
                    to="/dinh-cu-latvia/hop-tac"
                    className="text-gray-400 hover:text-amber-400 transition-colors text-sm"
                  >
                    {t('footer.services.partnership')}
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-amber-400">{t('footer.contact.title')}</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <i className="ri-map-pin-line text-lg mt-0.5 text-amber-500"></i>
                <div>
                  <p className="text-xs text-gray-500">{t('footer.contact.address')}</p>
                  <p className="text-sm text-gray-300">{t('footer.contact.addressValue')}</p>
                </div>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-phone-line text-lg mt-0.5 text-amber-500"></i>
                <div>
                  <p className="text-xs text-gray-500">{t('footer.contact.phone')}</p>
                  <p className="text-sm text-gray-300">+371 2572 6969</p>
                </div>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-mail-line text-lg mt-0.5 text-amber-500"></i>
                <div>
                  <p className="text-xs text-gray-500">{t('footer.contact.email')}</p>
                  <p className="text-sm text-gray-300">contact@thedaeg.com</p>
                </div>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-time-line text-lg mt-0.5 text-amber-500"></i>
                <div>
                  <p className="text-xs text-gray-500">{t('footer.contact.hours')}</p>
                  <p className="text-sm text-gray-300">{t('footer.contact.hoursValue')}</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-amber-400">{t('footer.follow.title')}</h3>
            <div className="flex space-x-3">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-amber-500/20 border border-white/10 hover:border-amber-500/40 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-amber-500/20 border border-white/10 hover:border-amber-500/40 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-amber-500/20 border border-white/10 hover:border-amber-500/40 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-amber-500/20 border border-white/10 hover:border-amber-500/40 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-youtube-fill text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-8 pt-8 text-center">
          <p className="text-gray-500 text-sm">
            {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
}